/**
 * UTM persistence: parse marketing query params on first hit,
 * persist to sessionStorage, expose getter for downstream APIs.
 */

const STORAGE_KEY = "pp_utm";
const KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
  "ref",
];

export function captureUtm() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const incoming = {};
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) incoming[k] = v;
  });

  // Default UTM attribution for the FB Ads landing variant
  if (window.location.pathname.startsWith("/oferta-fb")) {
    if (!incoming.utm_source) incoming.utm_source = "facebook";
    if (!incoming.utm_medium) incoming.utm_medium = "cpc";
  }

  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    stored = {};
  }

  const merged = { ...stored, ...incoming };
  if (Object.keys(incoming).length > 0) {
    merged.landing_path = window.location.pathname;
    merged.first_seen_at = stored.first_seen_at || new Date().toISOString();
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    } catch {
      /* ignore quota errors */
    }
  } else if (!stored.first_seen_at) {
    const seed = {
      landing_path: window.location.pathname,
      first_seen_at: new Date().toISOString(),
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(seed));
    } catch {
      /* ignore */
    }
  }
  return merged;
}

export function getUtm() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}
